import React from 'react';
import COInlineMessage from '@components/ringil3/COInlineMessage/COInlineMessage.tsx';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { describeRouteIssue, RouteOrderIssue } from '@app/pages/expedition/create/routeRules.ts';

interface ComponentProps {
  issues: RouteOrderIssue[];
}

// Lives in routeRules now, so the validation summary can use it without pulling React in.
export { describeRouteIssue };

/**
 * Everything wrong with the current route, listed together.
 *
 * Not dismissible: these have to be resolved before the shipment can be created, so the list stays
 * until the route is right.
 */
const RouteIssuesMessage: React.FC<ComponentProps> = ({ issues }) => {
  const { tr } = useTranslationLgs();

  if (issues.length === 0) return null;

  return (
    <COInlineMessage variant={'error'} dataTestId={'routeIssues'}>
      <div className={'flex flex-col gap-1'}>
        <strong>{tr('CreateExpedition.routeIssuesHeading', 'The route cannot be created yet')}</strong>
        <ul className={'m-0 flex list-disc flex-col gap-1 pl-4'}>
          {issues.map(issue => (
            <li key={`${issue.orderId}-${issue.type}`}>{describeRouteIssue(issue, tr)}</li>
          ))}
        </ul>
      </div>
    </COInlineMessage>
  );
};

export default RouteIssuesMessage;
